import { TMCTableModule } from '@sdbn/appclient';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivateTransportsDialogComponent } from './component/activate-transports-dialog.component';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    TMCTableModule,
    ApplicationClientCommonModule,
    ServiceResponseModule,
    CommonTranslationModule
  ],
  declarations: [ActivateTransportsDialogComponent]
})
export class ActivateTransportsModule { }
